module.exports = __webpack_public_path__ + "ffa92d83966100198d3c1d8cfeb373cf.svg";